// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3dALt","search":"Settings_search__1O8mo","filter":"Settings_filter__2RsS3"};